const CODEX_ROWS = [
  'idle', 'running-right', 'running-left', 'waving', 'jumping',
  'failed', 'waiting', 'running', 'review',
] as const;

const LEGACY_ROWS = [
  'idle', 'wave', 'run', 'failed', 'review', 'jump', 'extra-1', 'extra-2',
] as const;

export function rowNamesForGrid(rowCount: number): string[] {
  if (rowCount < CODEX_ROWS.length) return [...LEGACY_ROWS];

  const extra = Array.from(
    { length: rowCount - CODEX_ROWS.length },
    (_, i) => `custom-${i + 1}`,
  );
  return [...CODEX_ROWS, ...extra];
}

/** Canonical animation name → accepted row names, in descending preference.
 *  Lets one lookup serve both the current Codex taxonomy and legacy sheets. */
export const ROW_ALIASES: Record<string, readonly string[]> = {
  idle: ['idle'],
  waving: ['waving', 'wave'],
  jumping: ['jumping', 'jump'],
  running: ['running', 'run'],
  'running-left': ['running-left', 'running', 'run'],
  'running-right': ['running-right', 'running', 'run'],
  failed: ['failed'],
  waiting: ['waiting'],
  review: ['review'],
};
